import { createAction } from 'Lib/reduxUtils';

import { Product } from 'Store/entities/products.types';

import {
  CLEAR_ELIGIBILITY,
  CLEAR_GIFT_CARD,
  GET_GIFT_CARD_ELIGIBILITY,
  GET_INCENTIVE_ELIGIBILITY,
  GET_INCENTIVE_INTRO_PRICE_PRODUCT,
  GIFT_CARD_ELIGIBILITY_SUCCESS,
  GIFT_CARD_REDEEM,
  GIFT_CARD_REDEEM_SUCCESS,
  INCENTIVE_ELIGIBILITY_FAILURE,
  INCENTIVE_ELIGIBILITY_SUCCESS,
  INCENTIVE_INTRO_PRICE_PRODUCT_ERROR,
  INCENTIVE_INTRO_PRICE_PRODUCT_SUCCESS,
  INCENTIVE_INTRO_PRICE_REDEEM_ERROR,
  INCENTIVE_INTRO_PRICE_REDEEM_SUCCESS,
  INCENTIVE_IS_LOADING,
  INCENTIVE_REDEEM,
  INCENTIVE_REDEEM_ERROR,
  INCENTIVE_REDEEM_SUCCESS,
  REDEEM_INCENTIVE_INTRO_PRICE_PRODUCT,
  SET_INCENTIVE_PROMO_SOURCE,
} from './constants';

export const getIncentiveEligibility = createAction(
  GET_INCENTIVE_ELIGIBILITY,
  (promoCode: string) => ({ promoCode })
);
export const getIncentiveIntroPriceProduct = createAction(GET_INCENTIVE_INTRO_PRICE_PRODUCT);
export const incentiveEligibilitySuccess = createAction(
  INCENTIVE_ELIGIBILITY_SUCCESS,
  (payload: any) => payload
);
export const incentiveEligibilityFailure = createAction(
  INCENTIVE_ELIGIBILITY_FAILURE,
  (payload: any) => payload
);
export const redeemIncentive = createAction(INCENTIVE_REDEEM);
export const redeemIncentiveSuccess = createAction(INCENTIVE_REDEEM_SUCCESS);
export const redeemIncentiveError = createAction(INCENTIVE_REDEEM_ERROR, (payload: any) => payload);
export const clearEligibility = createAction(CLEAR_ELIGIBILITY);
export const setIncentivePromoSource = createAction(
  SET_INCENTIVE_PROMO_SOURCE,
  (payload: string) => payload
);
export const incentiveIsLoading = createAction(INCENTIVE_IS_LOADING);
export const incentiveIntroPriceProductSuccess = createAction(
  INCENTIVE_INTRO_PRICE_PRODUCT_SUCCESS,
  (payload: { result: Product }) => payload
);
export const incentiveIntroPriceProductError = createAction(
  INCENTIVE_INTRO_PRICE_PRODUCT_ERROR,
  (payload: string) => payload
);
export const redeemIncentiveIntroPriceProduct = createAction(
  REDEEM_INCENTIVE_INTRO_PRICE_PRODUCT,
  (payload: { postData: any; productType: string }) => payload
);
export const redeemIncentiveIntroPriceSuccess = createAction(
  INCENTIVE_INTRO_PRICE_REDEEM_SUCCESS,
  (payload: string) => payload
);
export const redeemIncentiveIntroPriceError = createAction(
  INCENTIVE_INTRO_PRICE_REDEEM_ERROR,
  (payload: string) => payload
);
export const getGiftCardEligibility = createAction(
  GET_GIFT_CARD_ELIGIBILITY,
  (cardNumber: string, cardPin: string) => ({ cardNumber, cardPin })
);
export const giftCardEligibilitySuccess = createAction(GIFT_CARD_ELIGIBILITY_SUCCESS);
export const redeemGiftCard = createAction(GIFT_CARD_REDEEM);
export const redeemGiftCardSuccess = createAction(
  GIFT_CARD_REDEEM_SUCCESS,
  (payload: any) => payload
);
export const clearGiftCard = createAction(CLEAR_GIFT_CARD);
